import React from 'react'
import ReactDOM from 'react-dom/client'
import { Amplify } from 'aws-amplify'
import App from './App.jsx'
import { AuthProvider } from './hooks/useAuth.jsx'
import './styles/index.css'

// Cognito Configuration
const cognitoConfig = {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-east-1_n0ESPoUk4',
  userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '186gm34jc2dnqf5fvk5r2b4t9g',
  region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
}

// OAuth domain - derive from user pool ID or use environment variable
const oauthDomain = import.meta.env.VITE_COGNITO_DOMAIN || 'navigator-vanderbilt.auth.us-east-1.amazoncognito.com'

// Determine redirect URLs based on environment
const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost'
const baseUrl = isLocalhost
  ? 'http://localhost:3000/'
  : 'https://navigator.vanderbilt.ai/'

// Configure Amplify
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: cognitoConfig.userPoolId,
      userPoolClientId: cognitoConfig.userPoolClientId,
      loginWith: {
        oauth: {
          domain: oauthDomain,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [baseUrl],
          redirectSignOut: [baseUrl],
          responseType: 'code',
        },
      },
    },
  },
}

Amplify.configure(amplifyConfig)

console.log('Amplify configured with:', {
  userPoolId: cognitoConfig.userPoolId,
  region: cognitoConfig.region,
  redirectUrl: baseUrl,
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
)
